@if (content) {
<modal-layout-right [modalTitle]="content.title">
    <div modalBody>
        <p class="p1"
           *iCms="'copy' of content; content: 'html'"></p>
        <div class="w-12 flex m-t-4"
             [style.gap.px]="15">
            <div [style.flex]="2">
                <div class="ratio-3-4 w-12">
                    <img class="rf"
                         [image]="content.firstImage">
                </div>
            </div>
            <div class="flex flex-column flex-justify-between"
                 [style.flex]="1">
                <div class="w-12 ratio-4-5">
                    <img class="rf"
                         [image]="content.secondImage">
                </div>
                <div class="w-12 ratio-4-5">
                    <img class="rf"
                         [image]="content.thirdImage">
                </div>
            </div>
        </div>
    </div>
</modal-layout-right>
}
